import React from 'react'
import { Layout, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  const showTab = (event, content) => {
    let tabContent = [...document.getElementsByClassName('c-tabs__content')]
    tabContent.forEach(content => {
      content.style.display = 'none'
    })

    let tabLinks = [...document.getElementsByClassName('c-tabs__tab')]
    tabLinks.forEach(tab => {
      tab.className = tab.className.replace(' c-tabs__tab--active', '')
    })

    document.getElementById(content).style.display = 'block'
    event.currentTarget.className += ' c-tabs__tab--active'
  }
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Showcase
          site={data.site}
          title="Tabs"
          text="The tab component consists of a container, a tab bar, text labels, and the tab content. In addition to the default state, the tab bar also has a hover state and a focus state. The selected and unselected states mark the active and inactive tabs, respectively."
          code={code.tabs}
        >
          <div>
            <div class="c-tabs">
              <div
                class="c-tabs__tab c-tabs__tab--active"
                onClick={event => showTab(event, 'content1')}
                onKeyDown={event => showTab(event, 'content1')}
                role="button"
                tabIndex={0}
              >
                Tab label 1
              </div>
              <div
                class="c-tabs__tab"
                onClick={event => showTab(event, 'content2')}
                onKeyDown={event => showTab(event, 'content2')}
                role="button"
                tabIndex={0}
              >
                Tab label 2
              </div>
            </div>
            <div
              id="content1"
              class="c-tabs__content c-tabs__content--active l-padding-vertical--medium"
            >
              <p class="c-text-content">This is the content for Tab 1.</p>
            </div>
            <div
              id="content2"
              class="c-tabs__content l-padding-vertical--medium"
            >
              <p class="c-text-content">This is the content for Tab 2.</p>
            </div>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  tabs: `<div>
  <div class="c-tabs">
    <div class="c-tabs__tab c-tabs__tab--active">Tab Label 1</div>
    <div class="c-tabs__tab">Tab Label 2</div>    
  </div>
  <div class="c-tabs__content c-tabs__content--active l-padding-vertical--medium">
    <p class="c-text-content">This is the content for Tab 1.</p>
  </div>
  <div class="c-tabs__content l-padding-vertical--medium">
    <p class="c-text-content">This is the content for Tab 2.</p>
  </div>  
</div>`,
}
